
import Vue, { PropType } from 'vue'
import StatsChart from '@/components/stats/StatsChart.vue'
import { formatDuration } from '@/services/time'
import { WorkstationDocument } from '@/api/types/workstation'
import { UsageDocument } from '@/store/types/event'

const getInitialChartData = () => {
  return {
    labels: [],
    datasets: [
      {
        label: 'Hours',
        backgroundColor: '#7979f8',
        data: [],
      },
    ],
  }
}

export default Vue.extend({
  name: 'Statistics',
  components: {
    StatsChart,
  },
  data() {
    return {
      chartData: getInitialChartData(),
    }
  },

  props: {
    usage: {
      type: Array as PropType<Array<UsageDocument>>,
      required: true,
    },
    user: { type: Object, required: true }, // TODO add proper typing as PropType<...>
    selected: { type: Object, required: true }, // ditto.
  },
  computed: {
    totalDuration(): number {
      const reducer = (acc: number, value: UsageDocument) => acc + (value.durationHours || 0)
      return this.usage.reduce(reducer, 0)
    },
    formattedDuration(): string {
      return formatDuration(this.totalDuration)
    },
    workstations(): Array<WorkstationDocument> {
      return this.user ? this.user.workstations : []
    },
    selectedWorkstations(): number {
      return this.workstations.filter((w) => this.selected[w.uuid] !== false).length
    },
    chartoptions(): Object {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      }
    },
  },
  methods: {
    updateChart() {
      let minTs = null
      let maxTs = null
      const hoursByYearMonth: any = {}
      for (const u of this.usage) {
        minTs = !minTs ? u.timestamp : Math.min(minTs, u.timestamp)
        maxTs = !maxTs ? u.timestamp : Math.min(maxTs, u.timestamp)
        const d = new Date(u.timestamp)
        const year = d.getFullYear()
        const month = d.getMonth()

        if (!hoursByYearMonth[year]) {
          hoursByYearMonth[year] = {}
        }

        if (!hoursByYearMonth[year][month]) {
          hoursByYearMonth[year][month] = 0
        }

        hoursByYearMonth[year][month] += u.durationHours || 0
      }
      const monthNames: Array<string> = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ]
      const result: any = getInitialChartData()
      for (const y of Object.keys(hoursByYearMonth)) {
        for (const m of Object.keys(hoursByYearMonth[y])) {
          result.labels.push(`${monthNames[m as any]} ${y}`)
          result.datasets[0].data.push(hoursByYearMonth[y][m].toFixed(2))
        }
      }
      Vue.set(this, 'chartData', result)
    },
  },
  mounted() {
    this.updateChart()
  },
  watch: {
    user() {
      this.updateChart()
    },
    selected: {
      handler() {
        this.updateChart()
      },
      deep: true,
    },
  },
})
